module.exports = __webpack_public_path__ + "static/media/gr-01.37351e57.png";